import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {brand} from '../../../../app/settings';

@Component({
    selector: 'app-star',
    templateUrl: './star.component.html',
    styleUrls: ['./star.component.scss']
})
/**
 * take in input :
 * level who can be 'bronze', 'locked', 'silver', 'platinium' or 'gold'
 * disabledStar who make an effect like if star was disabled
 * score : number in center of the star who can change dynamicly
 * provide in result a star with or without a number and with or without a blur effect.
 * we use in html this[level + 'png'] it permit to use directly the good png without extra code or ngif
 * ex: if level = 'silver' this will call the silverpng base64 picture
 */
export class StarComponent implements OnInit, AfterViewInit {
    @Input('level') level = '';
    @Input('score') score = '';
    @Input('disabledStar') disabledStar = false;

    public textPositionX: string = '28';
    public textPositionY: string = '39';

    constructor() {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        // adjust text position if is on two digit
        if (+this.score >= 10) {
            this.textPositionX = '24';
        }
    }

    public getImagePath(level: string): string {
        return `/assets/${brand}/images/star/${level}.png`;
    }
}
